import * as actionTypes from '../constants/actionTypes';

const initialState = {
  term: ''
};

function setSearchTerm(state, action) {
  const { term } = action;
  return { ...state, term };
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_SEARCH_TERM:
      return setSearchTerm(state, action);
    case actionTypes.CLEAR_TRANSIENT_UPDATES:
      return {...initialState};
    default:
      return state;
  }
}
